import React from 'react';
import StudentList from './StudentList';
import { FiUserX } from 'react-icons/fi';

const AdminInactiveStudents = () => {
  return (
    <StudentList
      title="Inactive Students"
      filterStatus="inactive"
      icon={<FiUserX color="#d32f2f" />}  // red cross icon
    />
  );
};

export default AdminInactiveStudents;
